import { render, staticRenderFns } from "./WorkspacesSettings.vue?vue&type=template&id=93a02cec"
import script from "./WorkspacesSettings.vue?vue&type=script&lang=js"
export * from "./WorkspacesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93a02cec')) {
      api.createRecord('93a02cec', component.options)
    } else {
      api.reload('93a02cec', component.options)
    }
    module.hot.accept("./WorkspacesSettings.vue?vue&type=template&id=93a02cec", function () {
      api.rerender('93a02cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/account-page/workspaces-settings/WorkspacesSettings.vue"
export default component.exports